import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../api/apiCaller";

/**
 * Consts
 */

export const GET_ROLE = "GET_ROLE";
export const GET_ROLE_SUCCESS = "GET_ROLE_SUCCESS";
export const GET_ROLE_ERROR = "GET_ROLE_ERROR";

export const COUNT_ROLE = "COUNT_ROLE";
export const COUNT_ROLE_SUCCESS = "COUNT_ROLE_SUCCESS";
export const COUNT_ROLE_ERROR = "COUNT_ROLE_ERROR";

export const ADD_ROLE = "ADD_ROLE";
export const ADD_ROLE_SUCCESS = "ADD_ROLE_SUCCESS";
export const ADD_ROLE_ERROR = "ADD_ROLE_ERROR";

export const EDIT_ROLE = "EDIT_ROLE";
export const EDIT_ROLE_SUCCESS = "EDIT_ROLE_SUCCESS";
export const EDIT_ROLE_ERROR = "EDIT_ROLE_ERROR";

export const DELETE_ROLE = "DELETE_ROLE";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_ERROR = "DELETE_ROLE_ERROR";

/**
 * Reducer
 */

const initialState = {
  roles: [],
  role: {},
  count: 0,
};

export const rolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ROLE:
      return {
        ...state,
      };

    case GET_ROLE_SUCCESS:
      return {
        ...state,
        roles: action.payload,
      };

    case GET_ROLE_ERROR:
      return {
        ...state,
        error: action.error,
      };

    // case ADD_ROLE:
    //     return {
    //         ...state
    //     }

    // case ADD_ROLE_SUCCESS:
    //     return {
    //         ...state,
    //         role: action.payload
    //     }

    // case ADD_ROLE_ERROR:
    //     return {
    //         ...state,
    //         error: action.error
    //     }

    case COUNT_ROLE:
      return {
        ...state,
      };

    case COUNT_ROLE_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };

    case COUNT_ROLE_ERROR:
      return {
        ...state,
        error: action.error,
      };

    // case EDIT_ROLE:
    //     return {
    //         ...state
    //     }

    // case EDIT_ROLE_SUCCESS:
    //     return {
    //         ...state,
    //         role: action.payload
    //     }

    // case EDIT_ROLE_ERROR:
    //     return {
    //         ...state,
    //         error: action.error
    //     }

    // case DELETE_ROLE:
    //     return {
    //         ...state
    //     }

    // case DELETE_ROLE_SUCCESS:
    //     return {
    //         ...state,
    //         role: action.payload
    //     }

    // case DELETE_ROLE_ERROR:
    //     return {
    //         ...state,
    //         error: action.error
    //     }

    default:
      return state;
  }
};

/**
 * Actions
 */

const getRole = (order, limit, skip, where) => ({
  type: GET_ROLE,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

// const countRole = (where) => ({
//     type: COUNT_ROLE,
//     data: {
//         where
//     }
// })

// const addRole = () => ({
//     type: ADD_ROLE,
//     data: {

//     }
// })

// const editRole = () => ({
//     type: EDIT_ROLE,
//     data: {

//     }
// })

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getRole,
      // addRole,
      // editRole,
      // countRole
    },
    dispatch
  );
};
/**
 * Apis
 */

const getRoleApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("access-mgt/role-create", {
    order,
    limit,
    skip,
    ...where,
  });
};

const countRoleApi = (where) => {
  return apiCaller.getData("access-mgt/role-create/count", { ...where });
};

// const addRoleApi = () => {
//     return apiCaller.post('/id/role-create', {})
// }

// const editRoleApi = (id, ) => {
//     return apiCaller.put(`/id/role-create/${id}`, {})
// }

// const deleteRoleApi = (id) => {
//     return apiCaller.del(`/id/role-create/${id}`)
// }

/**
 * sagas
 */

export const getRoleFlow = function* () {
  while (true) {
    yield take(GET_ROLE);
    try {
      const res = yield call(getRoleApi);
      yield put({
        type: GET_ROLE_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: GET_ROLE_ERROR, error });
    }
  }
};

// export const addRoleFlow = function* () {
//     while (true) {
//         const action = yield take(ADD_ROLE)
//         try {
//             const res = yield call(addRoleApi, action.data.role)
//             yield put({
//                 type: ADD_ROLE_SUCCESS, payload: {
//                     ...res.data
//                 }
//             })
//         } catch (error) {
//             yield put({ type: ADD_ROLE_ERROR, error })
//         }
//     }
// }

// export const editRoleFlow = function* () {
//     while (true) {
//         const action = yield take(EDIT_ROLE)
//         try {
//             const res = yield call(editRoleApi, )
//             yield put({
//                 type: EDIT_ROLE_SUCCESS, payload: {
//                     ...res.data
//                 }
//             })
//         } catch (error) {
//             yield put({ type: EDIT_ROLE_ERROR, error })
//         }
//     }
// }

// export const deleteRoleFlow = function* () {
//     while (true) {
//         const action = yield take(DELETE_ROLE)
//         try {
//             const res = yield call(deleteRoleApi, action.data.id)
//             yield put({
//                 type: DELETE_ROLE_SUCCESS, payload: {
//                     ...res.data
//                 }
//             })
//         } catch (error) {
//             yield put({ type: DELETE_ROLE_ERROR, error })
//         }
//     }
// }

export const countRoleFlow = function* () {
  while (true) {
    const action = yield take(COUNT_ROLE);
    try {
      const res = yield call(countRoleApi, action.data.id);
      yield put({
        type: COUNT_ROLE_SUCCESS,
        payload: {
          ...res.data,
        },
      });
    } catch (error) {
      yield put({ type: COUNT_ROLE_ERROR, error });
    }
  }
};
